import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";

function Resource({ resource }: Props) {
  return (
    <div className={styles.resource}>
      <p>{resource.name}</p>
    </div>
  );
}

export { Resource };
